















































































































import { Component, Mixins } from "vue-property-decorator";
import { Transaction } from "@foxone/api/src/models/defi";
import mixins from "@/mixins";
import { Colors } from "@/types";
import utils from "defi/utils";

@Component
class TransactionDetail extends Mixins(mixins.page) {
  loading = false;

  transition: Transaction | null = null;

  get appbar(): any {
    return {
      title: this.$t("common.transaction")
    };
  }

  get title() {
    return this.$t("common.transaction") as string;
  }

  get meta() {
    if (!this.transition) {
      return {};
    }
    const quantity = +this.transition.quantity;
    const amount = +this.transition.amount;
    const color = quantity > 0 ? Colors.RED : Colors.GREEN;
    const type = utils.enums.getTransactionTypeMeta(this.transition.type);
    const status = utils.enums.getTransactionStatusMeta(this.transition.status);
    return {
      color,
      name: this.transition.product_name,
      symbol: this.transition.asset.symbol.toUpperCase(),
      icon: this.transition.asset.icon,
      quantity: this.$common.utils.number.addSymbol(quantity),
      amount: this.$common.utils.number.addSymbol(amount),
      fee: this.transition.fee,
      typeText: this.$t(type.text),
      typeColor: type.color,
      stateText: this.$t(status.text),
      stateColor: status.color,
      traceId: this.transition.trace_id,
      createdAt: this.$common.utils.date.formatDate(
        +this.transition.created_at * 1000,
        "YYYY/MM/DD HH:mm:ss"
      ),
      updatedAt: this.$common.utils.date.formatDate(
        +this.transition.updated_at * 1000,
        "YYYY/MM/DD HH:mm:ss"
      ),
      comment: this.transition.comment
    };
  }

  get id() {
    return this.$route.params.id as string;
  }

  async requestTransactionDetail() {
    this.loading = true;
    const transition = await this.$api.defi.getTransitionDetail(this.id);
    this.transition = transition;
    this.loading = false;
  }

  mounted() {
    this.requestTransactionDetail();
  }
}
export default TransactionDetail;
